import { Stack as Bs5Stack } from 'react-bootstrap5';

export default Bs5Stack;
